import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ADD_USER_REQUEST_ASYNC,
  ASSIGN_COMPANIES_ASYNC,
  CHANGE_ALLOWED_MSP_ROLE_ID_FILTER,
  CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER,
  CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER,
  CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER,
  CHANGE_ASSIGNED_SELECTION_DATA,
  CHANGE_MSP_ROLE_FILTER,
  CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER,
  CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER,
  CHANGE_TO_ASSIGN_SELECTION_DATA,
  CNC_ACCESS_REQUEST_ASYNC,
  COMPANY_USERS_REQUEST_ASYNC,
  DATA_REQUEST_ASYNC,
  DELETE_USER_REQUEST_ASYNC,
  FILTER_SEARCH_CHANGE,
  FILTER_SEARCH_RESET,
  GET_MANAGEABLE_COMPANIES_ASYNC,
  GET_USER_INFO_ASYNC,
  GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC,
  GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC,
  MAKE_OWNER_ASYNC,
  PROFILES_REQUEST_ASYNC,
  RESET_ASSIGNED_SELECTION_DATA,
  RESET_TO_ASSIGN_SELECTION_DATA,
  RESET_USERS,
  ROLE_FILTER_CHANGE,
  SEARCH_CHANGE,
  SET_ASSIGNED_COMPANIES_FILTER,
  SET_ASSIGNED_COMPANIES_FILTER_PAGE,
  SET_TO_ASSIGN_COMPANIES_PAGE,
  SET_TO_ASSIGN_DRAWER_OPEN,
  SET_USER_ASSIGNED_COMPANIES_PAGE,
  UNASSIGN_COMPANIES_ASYNC,
  UPDATE_CNC_ACCESS_REQUEST_ASYNC,
  UPDATE_USER_REQUEST_ASYNC,
} from './constants'

const DEFAULT_SELECTION_DATA = {
  selectionIds: [],
  allItems: false,
}

export default function () {
  const initialState = {
    loader: false,
    data: {
      internalUsers: [],
      externalUsers: [],
    },
    profiles: [],
    error: null,
    actionError: null,
    search: '',
    addUserModalError: null,
    sortProperty: 'name-desc',
    mailBoxData: [],
    cncAccess: null,
    filterSearch: '',
    roleFilter: null,
    mspRoleFilter: null,
    manageableCompaniesData: {
      data: [],
      value: [],
      loader: false,
      error: null,
      page: 0,
    },
    userInfo: {
      data: {},
      loader: false,
      error: null,
    },
    assignedCompaniesData: {
      page: 1,
      loader: true,
      error: null,
      items: [],
      meta: {
        count: 0,
      },
    },
    toAssignCompaniesData: {
      page: 1,
      loader: false,
      error: null,
      items: [],
      meta: {
        count: 0,
      },
    },
    assignedCompaniesSearchFilter: '',
    toAssignCompaniesSearchFilter: '',
    assignedCompaniesMspRoleFilter: [],
    assignedCompaniesPLanTypeFilter: [],
    allowedMspRoleIdFilter: 1, // admin
    toAssignPlanTypeFilter: [],
    assignedSelectionData: DEFAULT_SELECTION_DATA,
    toAssignSelectionData: DEFAULT_SELECTION_DATA,
    isToAssignDrawerOpen: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
        return { ...state, loader: true }
      case FILTER_SEARCH_CHANGE:
        return {
          ...state,
          filterSearch: action.payload.q,
        }
      case FILTER_SEARCH_RESET:
        return {
          ...state,
          filterSearch: '',
        }
      case ROLE_FILTER_CHANGE:
        return {
          ...state,
          roleFilter: action.payload.value,
        }
      case COMPANY_USERS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
          actionError: null,
        }
      case COMPANY_USERS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          // data: {
          //   internalUsers: [
          //     {
          //       first_name: 'Anita',
          //       last_name: 'Bath',
          //       email: 'AnitaBath@t6p4p.onmicrosoft.com',
          //       role: 1,
          //       id: 187861,
          //       is_owner: true,
          //       user_type: 1,
          //       ioc_access: true,
          //       msp_roles: ['Owner', 'incident manager', 'Incident operator'],
          //       companies_count: 251,
          //     },
          //     {
          //       first_name: 'Arnold',
          //       last_name: 'Vova',
          //       email: 'Arnold_VY@t6p4p.onmicrosoft.com',
          //       role: 1,
          //       id: 416385,
          //       is_owner: false,
          //       user_type: 1,
          //       ioc_access: true,
          //       msp_roles: ['Owner', 'incident manager'],
          //       companies_count: 2,
          //     },
          //   ],
          //   externalUsers: [
          //     {
          //       // is_direct: true,
          //       is_direct: false,
          //       user_type: 2,
          //       company_name: 'Partner MSP Tenant',
          //       id: 1122,
          //       company_id: 4147,
          //       support_email: 'support@partner-MSP.com',
          //       role: 1,
          //     },
          //   ],
          //   isOwner: true,
          //   allowMspOwnerChanges: false,
          //   presumed_safe_emails_enabled: true,
          // },
          error: null,
          actionError: null,
          loader: false,
        }
      case COMPANY_USERS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
          actionError: null,
        }
      case COMPANY_USERS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case PROFILES_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case PROFILES_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          profiles: action.payload.data,
          loader: false,
          error: null,
          actionError: null,
        }
      case PROFILES_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case PROFILES_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case ADD_USER_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          addUserModalError: null,
          loader: true,
        }
      case ADD_USER_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          addUserModalError: null,
          loader: false,
        }
      case ADD_USER_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          addUserModalError: action.error.response.message,
          loader: false,
        }
      case ADD_USER_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case DELETE_USER_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          userToDelete: action.payload.user,
          loader: true,
          actionError: null,
        }
      case DELETE_USER_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, actionError: null }
      case DELETE_USER_REQUEST_ASYNC.ERROR:
        return { ...state, actionError: action.error }
      case DELETE_USER_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case MAKE_OWNER_ASYNC.INITIATE:
      case UPDATE_USER_REQUEST_ASYNC.INITIATE:
        const userToUpdate = {
          ...action.payload.user,
        }
        if (userToUpdate.iocAccess === null) {
          userToUpdate.iocAccess = false
        }
        return {
          ...state,
          userToUpdate,
          loader: true,
          actionError: null,
        }
      case MAKE_OWNER_ASYNC.SUCCESS:
      case UPDATE_USER_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, actionError: null }
      case MAKE_OWNER_ASYNC.ERROR:
      case UPDATE_USER_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          actionError: action.error,
          loader: false,
        }
      case MAKE_OWNER_ASYNC.CANCEL:
      case UPDATE_USER_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case SEARCH_CHANGE:
        return { ...state, search: action.payload.q }
      case DATA_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          mailBoxData: action.payload.data.items,
          loader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CNC_ACCESS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case CNC_ACCESS_REQUEST_ASYNC.SUCCESS:
        return { ...state, loader: false, cncAccess: action.payload.cncAccess }
      case CNC_ACCESS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case CNC_ACCESS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error }
      case UPDATE_CNC_ACCESS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case UPDATE_CNC_ACCESS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_CNC_ACCESS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case CHANGE_MSP_ROLE_FILTER:
        return {
          ...state,
          mspRoleFilter: action.payload.value,
        }
      case GET_MANAGEABLE_COMPANIES_ASYNC.INITIATE:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            loader: true,
            error: null,
          },
        }
      case GET_MANAGEABLE_COMPANIES_ASYNC.SUCCESS:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            data:
              state.manageableCompaniesData.page === 1
                ? action.payload.data.items
                : [...state.manageableCompaniesData.data, ...action.payload.data.items],
            loader: false,
          },
        }
      case GET_MANAGEABLE_COMPANIES_ASYNC.ERROR:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            error: action.error,
            loader: false,
          },
        }
      case GET_MANAGEABLE_COMPANIES_ASYNC.CANCEL:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            loader: false,
          },
        }
      case SET_ASSIGNED_COMPANIES_FILTER:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            value: action.payload.data,
          },
        }
      case SET_ASSIGNED_COMPANIES_FILTER_PAGE:
        return {
          ...state,
          manageableCompaniesData: {
            ...state.manageableCompaniesData,
            page: action.payload.page,
          },
        }
      case RESET_USERS:
        return {
          ...initialState,
        }
      case GET_USER_INFO_ASYNC.INITIATE:
        return {
          ...state,
          userInfo: {
            ...state.userInfo,
            loader: true,
            error: null,
          },
        }
      case GET_USER_INFO_ASYNC.SUCCESS:
        return {
          ...state,
          userInfo: {
            ...state.userInfo,
            data: action.payload.data,
            loader: false,
          },
        }
      case GET_USER_INFO_ASYNC.ERROR:
        return {
          ...state,
          userInfo: {
            ...state.userInfo,
            error: action.error,
            loader: false,
          },
        }
      case GET_USER_INFO_ASYNC.CANCEL:
        return {
          ...state,
          userInfo: {
            ...state.userInfo,
            loader: false,
          },
        }
      case CHANGE_ASSIGNED_COMPANIES_SEARCH_FILTER:
        return {
          ...state,
          assignedCompaniesSearchFilter: action.payload.q,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
          },
        }
      case CHANGE_ASSIGNED_COMPANIES_MSP_ROLE_FILTER:
        return {
          ...state,
          assignedCompaniesMspRoleFilter: action.payload.value,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
          },
        }
      case CHANGE_ASSIGNED_COMPANIES_PLAN_TYPE_FILTER:
        return {
          ...state,
          assignedCompaniesPLanTypeFilter: action.payload.value,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
          },
        }
      case GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.INITIATE:
        return {
          ...state,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
            error: null,
          },
        }
      case GET_USER_MANAGEABLE_ASSIGNED_COMPANIES_ASYNC.SUCCESS:
        return {
          ...state,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: false,
            ...action.payload.data,
          },
        }
      case CHANGE_ALLOWED_MSP_ROLE_ID_FILTER:
        return {
          ...state,
          allowedMspRoleIdFilter: action.payload.value,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: true,
          },
        }
      case CHANGE_TO_ASSIGN_PLAN_TYPE_FILTER:
        return {
          ...state,
          toAssignPlanTypeFilter: action.payload.value,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: true,
          },
        }
      case CHANGE_TO_ASSIGN_COMPANIES_SEARCH_FILTER:
        return {
          ...state,
          toAssignCompaniesSearchFilter: action.payload.q,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: true,
          },
        }
      case GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.INITIATE:
        return {
          ...state,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: true,
            error: null,
          },
        }
      case GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.SUCCESS:
        return {
          ...state,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: false,
            ...action.payload.data,
          },
        }
      case GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.ERROR:
        return {
          ...state,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            error: action.error,
            loader: false,
          },
        }
      case GET_USER_MANAGEABLE_TO_ASSIGN_COMPANIES_ASYNC.CANCEL:
        return {
          ...state,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            loader: false,
          },
        }
      case SET_USER_ASSIGNED_COMPANIES_PAGE:
        return {
          ...state,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            page: action.payload.page,
          },
        }
      case SET_TO_ASSIGN_COMPANIES_PAGE:
        return {
          ...state,
          toAssignCompaniesData: {
            ...state.toAssignCompaniesData,
            page: action.payload.page,
          },
        }
      case CHANGE_TO_ASSIGN_SELECTION_DATA:
        return {
          ...state,
          toAssignSelectionData: {
            ...state.toAssignSelectionData,
            [action.payload.field]: action.payload.value,
          },
        }
      case CHANGE_ASSIGNED_SELECTION_DATA:
        return {
          ...state,
          assignedSelectionData: {
            ...state.assignedSelectionData,
            [action.payload.field]: action.payload.value,
          },
        }
      case SET_TO_ASSIGN_DRAWER_OPEN:
        return {
          ...state,
          isToAssignDrawerOpen: action.payload.value,
        }
      case ASSIGN_COMPANIES_ASYNC.INITIATE:
      case UNASSIGN_COMPANIES_ASYNC.INITIATE:
        return {
          ...state,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
          },
        }
      case ASSIGN_COMPANIES_ASYNC.SUCCESS:
        return {
          ...state,
          isToAssignDrawerOpen: false,
          toAssignSelectionData: DEFAULT_SELECTION_DATA,
          assignedSelectionData: DEFAULT_SELECTION_DATA,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: true,
          },
        }
      case ASSIGN_COMPANIES_ASYNC.ERROR:
      case ASSIGN_COMPANIES_ASYNC.CANCEL:
        return {
          ...state,
          isToAssignDrawerOpen: false,
          toAssignSelectionData: DEFAULT_SELECTION_DATA,
          assignedSelectionData: DEFAULT_SELECTION_DATA,
        }
      case UNASSIGN_COMPANIES_ASYNC.SUCCESS:
      case UNASSIGN_COMPANIES_ASYNC.ERROR:
      case UNASSIGN_COMPANIES_ASYNC.CANCEL:
        return {
          ...state,
          assignedSelectionData: DEFAULT_SELECTION_DATA,
          assignedCompaniesData: {
            ...state.assignedCompaniesData,
            loader: false,
          },
        }
      case RESET_TO_ASSIGN_SELECTION_DATA: {
        return {
          ...state,
          toAssignSelectionData: DEFAULT_SELECTION_DATA,
        }
      }
      case RESET_ASSIGNED_SELECTION_DATA: {
        return {
          ...state,
          assignedSelectionData: DEFAULT_SELECTION_DATA,
        }
      }
      default:
        return state
    }
  }
}
